module.exports = __webpack_public_path__ + "static/vtr-logo-ceba0d4a75cc84e54b09ed248b843cb0.png";